export default ({ dropdown }) => ({
  dark: {},
  header: {
    '&$dark': {
      color: dropdown.dark.optionHeader,
    },
    color: dropdown.optionHeader,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '32px',
    textTransform: 'uppercase',
    padding: [4, 12, 4, 0],
    paddingLeft: ({ depth }) => 15 * depth,
  },
});
